import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import Iframe from "react-iframe";
import "../css/Admin_css/admin-customize.css";
import COLORS from "../resources/colors/COLORS";
import myToast from "../Utils/MyToast";
import SessionManager from "../Utils/SessionManager";
import axios from "axios";

const HEADER_GRADIENT = `linear-gradient(135deg, ${COLORS.primary_color_shade7 || "#01579B"} 0%, ${COLORS.primary_color_shade8 || "#0277BD"} 100%)`;
const DOCUMENT_TYPE = "fee_receipt";

function buildReceiptUrlFromSample(sample, studentId, sessionId, transactionId) {
  if (!sample?.file_directory || !sample?.file_name) return "";

  const schoolCode = SessionManager.getSchoolCode();
  return (
    process.env.REACT_APP_SERVER_NAME +
    sample.file_directory +
    sample.file_name +
    `?&student_id=${encodeURIComponent(studentId)}` +
    `&session_id=${encodeURIComponent(sessionId)}` +
    `&transaction_id=${encodeURIComponent(transactionId)}` +
    `&system_code=${encodeURIComponent(process.env.REACT_APP_SYSTEM_CODE || "")}` +
    `&school_code=${encodeURIComponent(schoolCode || "")}` +
    `&SchoolCopy=0`
  );
}

function buildFallbackReceiptUrl(studentId, sessionId, transactionId) {
  const schoolCode = SessionManager.getSchoolCode();
  const baseUrl =
    process.env.REACT_APP_SERVER_NAME +
    process.env.REACT_APP_TARGET_DIR_PRINTABLE +
    "FeeReceipt/fee_receipt_sample1.php?";

  return (
    baseUrl +
    `&student_id=${encodeURIComponent(studentId)}` +
    `&session_id=${encodeURIComponent(sessionId)}` +
    `&transaction_id=${encodeURIComponent(transactionId)}` +
    `&system_code=${encodeURIComponent(process.env.REACT_APP_SYSTEM_CODE || "")}` +
    `&school_code=${encodeURIComponent(schoolCode || "")}` +
    `&SchoolCopy=0`
  );
}

function formatINR(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return "0";
  return new Intl.NumberFormat("en-IN", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(n);
}

function formatDisplayDate(value) {
  if (!value) return "—";
  const datePart = String(value).trim().split(/[\sT]/)[0];
  const parts = datePart.split("-");
  if (parts.length >= 3) {
    return `${parts[2]}-${parts[1]}-${parts[0]}`;
  }
  return datePart;
}

const CHIP_THEMES = {
  default: {
    background: `linear-gradient(135deg, ${COLORS.white} 0%, ${COLORS.grey0 || "#FAFAFA"} 100%)`,
    border: `1px solid ${COLORS.grey3 || "#E0E0E0"}`,
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
    iconBg: COLORS.primary_color_shade0 || "#E1F5FE",
    iconColor: COLORS.primary_color_shade7 || "#0288D1",
    labelColor: COLORS.black6 || "#666",
    valueColor: COLORS.black8 || "#333",
  },
  amount: {
    background: HEADER_GRADIENT,
    border: "none",
    boxShadow: "0 3px 12px rgba(2, 119, 189, 0.25)",
    iconBg: "rgba(255, 255, 255, 0.22)",
    iconColor: COLORS.white,
    labelColor: "rgba(255, 255, 255, 0.92)",
    valueColor: COLORS.white,
  },
  date: {
    background: `linear-gradient(135deg, ${COLORS.green_light || "#E8F5E9"} 0%, ${COLORS.white} 100%)`,
    border: `1px solid ${COLORS.green_dark || "#43A047"}`,
    boxShadow: "0 2px 8px rgba(46, 125, 50, 0.1)",
    iconBg: COLORS.card_green || "#33B536",
    iconColor: COLORS.white,
    labelColor: COLORS.leaf_green || "#2E7D32",
    valueColor: COLORS.black8 || "#333",
  },
  receipt: {
    background: `linear-gradient(135deg, ${COLORS.primary_color_shade0 || "#E1F5FE"} 0%, ${COLORS.white} 100%)`,
    border: `1px solid ${COLORS.primary_color_shade2 || "#81D4FA"}`,
    boxShadow: "0 2px 10px rgba(2, 136, 209, 0.12)",
    iconBg: COLORS.primary_color_shade7 || "#0288D1",
    iconColor: COLORS.white,
    labelColor: COLORS.primary_color_shade8 || "#0277BD",
    valueColor: COLORS.primary_color_shade9 || "#01579B",
  },
};

function SummaryChip({ label, value, icon, variant = "default", valueStyle }) {
  const theme = CHIP_THEMES[variant] || CHIP_THEMES.default;

  return (
    <div
      className="fee-payment-status-summary-chip"
      style={{
        display: "flex",
        alignItems: "center",
        gap: "12px",
        padding: "7px 5px",
        borderRadius: "14px",
        background: theme.background,
        border: theme.border,
        boxShadow: theme.boxShadow,
        minWidth: 0,
        width: "100%",
        minHeight: "80px",
        boxSizing: "border-box",
      }}
    >
      <div
        style={{
          width: "42px",
          height: "42px",
          borderRadius: "11px",
          background: theme.iconBg,
          color: theme.iconColor,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "18px",
          flexShrink: 0,
          boxShadow: variant === "amount" ? "none" : "0 2px 6px rgba(0,0,0,0.08)",
        }}
      >
        <i className={`fa ${icon}`} aria-hidden="true" />
      </div>
      <div style={{ minWidth: 0, flex: 1 }}>
        <div
          style={{
            fontSize: "11px",
            fontWeight: 700,
            color: theme.labelColor,
            textTransform: "uppercase",
            letterSpacing: "0.06em",
            lineHeight: 1.2,
          }}
        >
          {label}
        </div>
        <div
          style={{
            fontSize: variant === "amount" ? "22px" : "16px",
            fontWeight: 800,
            color: theme.valueColor,
            marginTop: "6px",
            lineHeight: 1.25,
            wordBreak: "break-word",
            fontVariantNumeric: "tabular-nums",
            ...valueStyle,
          }}
        >
          {value}
        </div>
      </div>
    </div>
  );
}

function SectionCard({ icon, title, children, style }) {
  return (
    <div
      style={{
        background: COLORS.white,
        border: `1px solid ${COLORS.primary_color_shade2 || "#81D4FA"}`,
        borderRadius: "14px",
        padding: "14px 16px",
        marginBottom: "12px",
        boxShadow: "0 2px 10px rgba(2, 136, 209, 0.08)",
        ...style,
      }}
    >
      {title && (
        <div
          style={{
            fontSize: "12px",
            fontWeight: 700,
            color: COLORS.black8 || "#333",
            marginBottom: "10px",
            display: "flex",
            alignItems: "center",
            gap: "8px",
            textTransform: "uppercase",
            letterSpacing: "0.05em",
          }}
        >
          <span
            style={{
              width: "28px",
              height: "28px",
              borderRadius: "8px",
              background: COLORS.primary_color_shade0 || "#E1F5FE",
              color: COLORS.primary_color_shade7 || "#0288D1",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "13px",
            }}
          >
            <i className={`fa ${icon}`} aria-hidden="true" />
          </span>
          {title}
        </div>
      )}
      {children}
    </div>
  );
}

/**
 * Regular Fee Payment Status dialog
 */
const MdlFeePaymentStatus = ({
  show = true,
  onClose,
  transactionId,
  studentId,
  sessionId,
  sessionName,
  collectedAmount,
}) => {
  const [modalShow, setModalShow] = useState(show);
  const [loadingReceipt, setLoadingReceipt] = useState(false);
  const [receiptUrl, setReceiptUrl] = useState("");
  const [receiptNo, setReceiptNo] = useState("");
  const [newReceiptNo, setNewReceiptNo] = useState("");
  const [updatingReceipt, setUpdatingReceipt] = useState(false);
  const [whatsappOption, setWhatsappOption] = useState("details");
  const [effectiveCollectedAmount, setEffectiveCollectedAmount] = useState(
    collectedAmount || 0
  );
  const [transactionDate, setTransactionDate] = useState("");
  const [collectionDate, setCollectionDate] = useState("");
  const [studentPhone, setStudentPhone] = useState("");
  const [printableSamples, setPrintableSamples] = useState([]);
  const [selectedSamplePosition, setSelectedSamplePosition] = useState(0);
  const [loadingSamples, setLoadingSamples] = useState(false);

  useEffect(() => {
    setModalShow(show);
  }, [show]);

  const applyReceiptSample = (position, samples = printableSamples) => {
    if (!transactionId || !studentId || !sessionId) return;

    const sample = samples[position];
    let url = sample
      ? buildReceiptUrlFromSample(sample, studentId, sessionId, transactionId)
      : "";

    if (!url) {
      url = buildFallbackReceiptUrl(studentId, sessionId, transactionId);
    }

    setLoadingReceipt(true);
    setReceiptUrl(url);
  };

  const getPrintableSamples = () => {
    const schoolCode = SessionManager.getSchoolCode();
    if (!schoolCode || !transactionId || !studentId || !sessionId) return;

    setLoadingSamples(true);
    const url =
      process.env.REACT_APP_SERVER_NAME +
      process.env.REACT_APP_TARGET_DIR +
      "getPrintableSample.php?";

    axios
      .get(url, {
        params: {
          school_code: schoolCode,
          document_type: DOCUMENT_TYPE,
        },
      })
      .then((res) => res.data)
      .then((response) => {
        setLoadingSamples(false);
        if (response.api_status === "OK" && Array.isArray(response.data)) {
          setPrintableSamples(response.data);
          setSelectedSamplePosition(0);
          applyReceiptSample(0, response.data);
        } else {
          setPrintableSamples([]);
          setSelectedSamplePosition(0);
          applyReceiptSample(0, []);
          if (response.api_remark) {
            myToast.notify_warning(response.api_remark);
          }
        }
      })
      .catch((error) => {
        setLoadingSamples(false);
        setPrintableSamples([]);
        applyReceiptSample(0, []);
        console.error("getPrintableSample error:", error);
      });
  };

  useEffect(() => {
    if (!modalShow || !transactionId || !studentId || !sessionId) return;
    getPrintableSamples();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalShow, transactionId, studentId, sessionId]);

  const handleChangeSample = (position) => {
    setSelectedSamplePosition(position);
    applyReceiptSample(position);
  };

  useEffect(() => {
    if (!studentId) return;

    const FUNCTION_NAME = "getStudentContactDetails.php?";
    const URL =
      process.env.REACT_APP_SERVER_NAME +
      process.env.REACT_APP_TARGET_DIR +
      FUNCTION_NAME;

    axios
      .get(URL, { params: { student_id: studentId } })
      .then((res) => res.data)
      .then((response) => {
        if (response.api_status === "OK" && Array.isArray(response.data)) {
          const first = response.data[0];
          const raw = first?.contact_number || "";
          const digits = (raw || "").replace(/\D/g, "");
          const withCountry =
            digits.length === 10 ? `91${digits}` : digits || "";
          setStudentPhone(withCountry);
        } else if (response.api_remark) {
          console.log("getStudentContactDetails remark:", response.api_remark);
        }
      })
      .catch((error) => {
        console.error("getStudentContactDetails error:", error);
      });
  }, [studentId]);

  useEffect(() => {
    if (!transactionId || !sessionId) return;

    const SCHOOL_CODE = SessionManager.getSchoolCode();
    if (!SCHOOL_CODE) return;

    const FUNCTION_NAME = "getPaymentDetails.php?";
    const URL =
      process.env.REACT_APP_SERVER_NAME +
      process.env.REACT_APP_TARGET_DIR +
      FUNCTION_NAME;

    axios
      .get(URL, {
        params: {
          school_code: SCHOOL_CODE,
          session_id: sessionId,
          transaction_id: transactionId,
        },
      })
      .then((res) => res.data)
      .then((response) => {
        if (response.api_status === "OK" && response.data?.length > 0) {
          const payload = response.data[0];
          if (payload.receipt_no) {
            setReceiptNo(payload.receipt_no);
            setNewReceiptNo(payload.receipt_no);
          }
          const items = payload.payment_details || [];
          const firstPayment = items[0];
          if (firstPayment?.transaction_date) {
            setTransactionDate(firstPayment.transaction_date);
          }
          if (firstPayment?.collection_date) {
            setCollectionDate(firstPayment.collection_date);
          }
          if (!collectedAmount && items.length > 0) {
            const total = items.reduce(
              (sum, item) => sum + (Number(item.amount_paid) || 0),
              0
            );
            setEffectiveCollectedAmount(total);
          }
        } else if (response.api_remark) {
          myToast.notify_warning(response.api_remark);
        }
      })
      .catch((error) => {
        console.error("getPaymentDetails error:", error);
      });
  }, [transactionId, sessionId, collectedAmount]);

  const handleClose = () => {
    setModalShow(false);
    if (onClose) onClose();
  };

  const handleUpdateReceiptNo = () => {
    const trimmed = (newReceiptNo || "").trim();
    if (!trimmed) {
      myToast.notify_warning("Please enter a valid receipt number");
      return;
    }

    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const staffData = SessionManager.getStaffDetails();
    const STAFF_ID = staffData?.staff_id || "";

    if (!SCHOOL_CODE || !STAFF_ID) {
      myToast.notify_error("Missing staff or school information");
      return;
    }

    setUpdatingReceipt(true);

    const FUNCTION_NAME = "updateReceiptNo.php";
    const URL =
      process.env.REACT_APP_SERVER_NAME +
      process.env.REACT_APP_TARGET_DIR +
      FUNCTION_NAME;

    const formData = new URLSearchParams();
    formData.append("staff_id", STAFF_ID);
    formData.append("school_code", SCHOOL_CODE);
    formData.append("transaction_id", transactionId || "");
    formData.append("receipt_no", receiptNo || "");
    formData.append("receipt_no_new", trimmed);

    axios
      .post(URL, formData)
      .then((res) => res.data)
      .then((response) => {
        setUpdatingReceipt(false);
        if (response.api_status === "OK") {
          setReceiptNo(trimmed);
          setNewReceiptNo(trimmed);
          myToast.notify_success("Changes saved successfully");
        } else {
          myToast.notify_warning(
            response.api_remark || "Failed to update receipt number"
          );
        }
      })
      .catch((error) => {
        setUpdatingReceipt(false);
        console.error("updateReceiptNo error:", error);
        myToast.notify_error("Error updating receipt number");
      });
  };

  const buildCollectionDetailsText = () => {
    const parts = [];
    if (sessionName) parts.push(`Session: ${sessionName}`);
    if (studentId) parts.push(`Student ID: ${studentId}`);
    if (transactionId) parts.push(`Txn: ${transactionId}`);
    if (typeof effectiveCollectedAmount === "number") {
      parts.push(`Collected: ₹${effectiveCollectedAmount.toLocaleString()}`);
    }
    if (receiptNo) parts.push(`Receipt No: ${receiptNo}`);
    return `Fee Collection\n${parts.join("\n")}`;
  };

  const buildReceiptLinkText = () => {
    if (!receiptUrl) return "";
    return `Fee Receipt:\n${receiptUrl}`;
  };

  const handleWhatsAppShare = (type) => {
    let text = "";
    if (type === "details") text = buildCollectionDetailsText();
    else if (type === "receipt") text = buildReceiptLinkText();
    else if (type === "both") {
      text = [buildCollectionDetailsText(), buildReceiptLinkText()]
        .filter(Boolean)
        .join("\n\n");
    }
    if (!text) {
      myToast.notify_warning("Nothing to share");
      return;
    }
    const base = studentPhone ? `https://wa.me/${studentPhone}` : `https://wa.me/`;
    const separator = base.includes("?") ? "&" : "?";
    window.open(`${base}${separator}text=${encodeURIComponent(text)}`, "_blank");
  };

  const selectedSampleName =
    printableSamples[selectedSamplePosition]?.sample_name || "Default template";

  const summaryChipCount = receiptNo ? 5 : 4;

  return (
    <Modal
      show={modalShow}
      onHide={handleClose}
      animation={false}
      size="xl"
      aria-labelledby="fee-payment-status-title"
      centered
      backdrop="static"
      dialogClassName="fee-payment-status-modal"
      backdropClassName="fee-payment-status-backdrop"
      contentClassName="fee-payment-status-content"
    >
      <div
        style={{
          background: COLORS.white,
          borderRadius: "20px",
          overflow: "hidden",
          boxShadow: "0 24px 64px rgba(0, 0, 0, 0.28)",
          display: "flex",
          flexDirection: "column",
          maxHeight: "90vh",
        }}
      >
        <Modal.Header
          closeButton
          style={{
            background: HEADER_GRADIENT,
            color: COLORS.white,
            border: "none",
            padding: "20px 24px",
            minHeight: "80px",
            position: "relative",
            overflow: "hidden",
            alignItems: "center",
          }}
        >
          <div
            style={{
              position: "absolute",
              top: "-30px",
              right: "-10px",
              width: "120px",
              height: "120px",
              background: "rgba(255, 255, 255, 0.12)",
              borderRadius: "50%",
              filter: "blur(20px)",
            }}
          />
          <Modal.Title
            id="fee-payment-status-title"
            style={{
              fontWeight: 800,
              fontSize: "20px",
              display: "flex",
              alignItems: "center",
              gap: "14px",
              position: "relative",
              zIndex: 1,
              width: "100%",
              lineHeight: 1.2,
            }}
          >
            <div
              style={{
                width: "48px",
                height: "48px",
                borderRadius: "14px",
                background: "rgba(255, 255, 255, 0.22)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
                boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
              }}
            >
              <i className="fa fa-check-circle" style={{ fontSize: "22px" }} />
            </div>
            <div>
              <div>Fee Payment Status</div>
              <div
                style={{
                  fontSize: "13px",
                  fontWeight: 500,
                  opacity: 0.92,
                  marginTop: "4px",
                }}
              >
                Collection submitted — review receipt and details
              </div>
            </div>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body
          style={{
            padding: "18px 22px",
            overflowY: "auto",
            overflowX: "hidden",
            flex: "1 1 auto",
            background: `linear-gradient(to bottom, ${COLORS.grey0 || "#FAFAFA"} 0%, ${COLORS.white} 100%)`,
          }}
        >
          {/* Success banner */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "14px",
              padding: "12px 16px",
              marginBottom: "14px",
              borderRadius: "12px",
              background: `linear-gradient(135deg, ${COLORS.green_light || "#E8F5E9"} 0%, ${COLORS.white} 100%)`,
              border: `1px solid ${COLORS.green_dark || "#43A047"}`,
              boxShadow: "0 2px 8px rgba(46, 125, 50, 0.1)",
            }}
          >
            <div
              style={{
                width: "44px",
                height: "44px",
                borderRadius: "12px",
                background: COLORS.card_green || "#33B536",
                color: COLORS.white,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "22px",
                flexShrink: 0,
              }}
            >
              <i className="fa fa-check" aria-hidden="true" />
            </div>
            <div>
              <div
                style={{
                  fontSize: "16px",
                  fontWeight: 800,
                  color: COLORS.leaf_green || "#2E7D32",
                }}
              >
                Collection Submitted Successfully
              </div>
              {sessionName && (
                <div
                  style={{
                    fontSize: "12px",
                    fontWeight: 600,
                    color: COLORS.black6 || "#666",
                    marginTop: "2px",
                  }}
                >
                  {sessionName}
                </div>
              )}
            </div>
          </div>

          {/* Summary chips */}
          <div
            className="fee-payment-status-summary-chips"
            style={{ "--chip-cols": summaryChipCount }}
          >
            <SummaryChip
              icon="fa-barcode"
              label="Transaction ID"
              value={transactionId || "—"}
              valueStyle={{ fontSize: "14px", wordBreak: "break-all" }}
            />
            <SummaryChip
              icon="fa-rupee-sign"
              label="Collected Amount"
              value={`₹${formatINR(effectiveCollectedAmount)}`}
              variant="amount"
            />
            <SummaryChip
              icon="fa-calendar-check"
              label="Collection Date"
              value={formatDisplayDate(collectionDate)}
              variant="date"
            />
            <SummaryChip
              icon="fa-calendar"
              label="Transaction Date"
              value={formatDisplayDate(transactionDate)}
              variant="date"
            />
            {receiptNo && (
              <SummaryChip
                icon="fa-receipt"
                label="Default Receipt No"
                value={receiptNo}
                variant="receipt"
                valueStyle={{ fontSize: "18px" }}
              />
            )}
          </div>

          {/* Edit receipt number */}
          <div className="fee-receipt-edit-card">
            <div className="fee-receipt-edit-icon">
              <i className="fa fa-pencil" aria-hidden="true" />
            </div>
            <div className="fee-receipt-edit-body">
              <div className="fee-receipt-edit-label">
                Edit Receipt No
                {receiptNo && (
                  <span className="fee-receipt-edit-default">
                    Default: {receiptNo}
                  </span>
                )}
              </div>
              <div className="fee-receipt-edit-row">
                <input
                  type="text"
                  className="fee-receipt-input"
                  placeholder={receiptNo ? `Default ${receiptNo}` : "Enter receipt number"}
                  value={newReceiptNo}
                  onChange={(e) => setNewReceiptNo(e.target.value)}
                />
                <button
                  type="button"
                  className="fee-payment-status-save-btn fee-receipt-save-btn"
                  onClick={handleUpdateReceiptNo}
                  disabled={updatingReceipt}
                >
                  <i
                    className={`fa ${updatingReceipt ? "fa-spinner fa-spin" : "fa-check"}`}
                    aria-hidden="true"
                  />
                  {updatingReceipt ? "Saving…" : "Save"}
                </button>
              </div>
            </div>
          </div>

          {false && (
            <SectionCard icon="fa-whatsapp" title="WhatsApp Share">
              <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                <button
                  type="button"
                  onClick={() => {
                    setWhatsappOption("details");
                    handleWhatsAppShare("details");
                  }}
                  className="btn btn-success"
                  style={{
                    backgroundColor: "#25D366",
                    borderColor: "#25D366",
                    minWidth: 160,
                  }}
                >
                  Collection Details
                </button>
                <button
                  type="button"
                  onClick={() => {
                    setWhatsappOption("receipt");
                    handleWhatsAppShare("receipt");
                  }}
                  className="btn btn-success"
                  style={{
                    backgroundColor: "#25D366",
                    borderColor: "#25D366",
                    minWidth: 160,
                  }}
                >
                  Receipt In Pdf
                </button>
                <button
                  type="button"
                  onClick={() => {
                    setWhatsappOption("both");
                    handleWhatsAppShare("both");
                  }}
                  className="btn btn-success"
                  style={{
                    backgroundColor: "#25D366",
                    borderColor: "#25D366",
                    minWidth: 160,
                  }}
                >
                  Details + Receipt
                </button>
              </div>
            </SectionCard>
          )}

          <div className="fee-receipt-section">
            <div className="fee-receipt-section-header">
              <div className="fee-receipt-section-title">
                <span className="fee-receipt-section-icon">
                  <i className="fa fa-eye" aria-hidden="true" />
                </span>
                Fee Receipt Preview
              </div>
              <span className="fee-receipt-section-badge">{selectedSampleName}</span>
            </div>

            {loadingSamples ? (
              <div className="fee-receipt-loading">
                <i className="fa fa-spinner fa-spin" aria-hidden="true" />
                Loading templates…
              </div>
            ) : printableSamples.length > 0 ? (
              <div className="fee-receipt-templates">
                <p className="fee-receipt-templates-label">Select Template</p>
                <div className="fee-receipt-template-grid">
                  {printableSamples.map((item, index) => {
                    const selected = selectedSamplePosition === index;
                    return (
                      <button
                        key={`${item.sample_name || "sample"}-${index}`}
                        type="button"
                        className={`fee-receipt-template-btn${selected ? " is-selected" : ""}`}
                        onClick={() => handleChangeSample(index)}
                        title={item.sample_name}
                      >
                        <span className="fee-receipt-template-icon">
                          <i
                            className={`fa ${selected ? "fa-check-circle" : "fa-file"}`}
                            aria-hidden="true"
                          />
                        </span>
                        <span className="fee-receipt-template-name">
                          {item.sample_name}
                        </span>
                      </button>
                    );
                  })}
                </div>
              </div>
            ) : (
              <div className="fee-receipt-fallback-note">
                <i className="fa fa-info-circle" aria-hidden="true" />
                Default receipt template (no custom templates configured)
              </div>
            )}

            <div className="fee-receipt-preview-frame">
              {(loadingReceipt || loadingSamples) && (
                <div className="fee-receipt-preview-overlay" aria-busy="true">
                  <i className="fa fa-spinner fa-spin" aria-hidden="true" />
                  <span>Loading receipt…</span>
                </div>
              )}
              {receiptUrl && (
                <Iframe
                  url={receiptUrl}
                  width="100%"
                  height="1400px"
                  display="initial"
                  position="relative"
                  scrolling="no"
                  frameBorder="0"
                  style={{ border: "none", overflow: "hidden", display: "block" }}
                  onLoad={() => setLoadingReceipt(false)}
                />
              )}
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer
          style={{
            borderTop: `1px solid ${COLORS.grey2 || "#EEEEEE"}`,
            padding: "14px 22px",
            background: COLORS.white,
            border: "none",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <Button
            variant="secondary"
            onClick={handleClose}
            style={{
              padding: "10px 24px",
              borderRadius: "12px",
              border: `2px solid ${COLORS.grey3 || "#E0E0E0"}`,
              background: COLORS.white,
              color: COLORS.black8 || "#333",
              fontWeight: 700,
              fontSize: "14px",
              minWidth: "100px",
            }}
          >
            Close
          </Button>
        </Modal.Footer>
      </div>

      <style>{`
        .fee-payment-status-backdrop {
          background-color: rgba(0, 0, 0, 0.55);
          backdrop-filter: blur(4px);
        }
        .fee-payment-status-modal .modal-dialog {
          max-width: min(1140px, calc(100vw - 32px));
          width: 100%;
        }
        .fee-payment-status-summary-chips {
          display: grid;
          width: 100%;
          grid-template-columns: repeat(var(--chip-cols, 4), minmax(0, 1fr));
          gap: 12px;
          margin-bottom: 14px;
        }
        @media (max-width: 992px) {
          .fee-payment-status-summary-chips {
            grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
          }
        }
        @media (max-width: 576px) {
          .fee-payment-status-summary-chips {
            grid-template-columns: 1fr !important;
          }
        }
        .fee-payment-status-content {
          border-radius: 20px;
          overflow: hidden;
          border: none;
          box-shadow: 0 24px 64px rgba(0, 0, 0, 0.28);
          max-height: 90vh;
          display: flex;
          flex-direction: column;
        }
        .fee-payment-status-modal .modal-content {
          border-radius: 20px;
          overflow: hidden;
          border: none;
          max-height: 90vh;
        }
        .fee-payment-status-modal .modal-header {
          border-radius: 20px 20px 0 0;
          min-height: 80px;
          flex-shrink: 0;
        }
        .fee-payment-status-modal .modal-footer {
          border-radius: 0 0 20px 20px;
          flex-shrink: 0;
        }
        .fee-payment-status-modal .modal-body::-webkit-scrollbar {
          width: 8px;
        }
        .fee-payment-status-modal .modal-body::-webkit-scrollbar-track {
          background: ${COLORS.grey1 || "#F5F5F5"};
          border-radius: 4px;
        }
        .fee-payment-status-modal .modal-body::-webkit-scrollbar-thumb {
          background: ${COLORS.primary_color_shade3 || "#4FC3F7"};
          border-radius: 4px;
        }
        .fee-payment-status-modal .modal-header .btn-close {
          filter: brightness(0) invert(1);
          opacity: 0.92;
          z-index: 2;
        }
        .fee-payment-status-modal .modal-header .btn-close:hover {
          opacity: 1;
        }
        .fee-payment-status-save-btn {
          color: ${COLORS.white} !important;
        }
        .fee-payment-status-save-btn:disabled {
          color: ${COLORS.white} !important;
        }
        .fee-receipt-edit-card {
          display: flex;
          align-items: flex-start;
          gap: 12px;
          padding: 10px 12px;
          margin-bottom: 12px;
          border-radius: 14px;
          background: ${COLORS.white};
          border: 1px solid ${COLORS.primary_color_shade2 || "#81D4FA"};
          box-shadow: 0 2px 10px rgba(2, 136, 209, 0.08);
        }
        .fee-receipt-edit-icon {
          width: 38px;
          height: 38px;
          border-radius: 10px;
          background: ${COLORS.primary_color_shade0 || "#E1F5FE"};
          color: ${COLORS.primary_color_shade7 || "#0288D1"};
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 15px;
          flex-shrink: 0;
        }
        .fee-receipt-edit-body {
          flex: 1;
          min-width: 0;
        }
        .fee-receipt-edit-label {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          gap: 8px;
          font-size: 11px;
          font-weight: 700;
          color: ${COLORS.black7 || "#555"};
          text-transform: uppercase;
          letter-spacing: 0.05em;
          margin-bottom: 8px;
        }
        .fee-receipt-edit-default {
          font-size: 10px;
          font-weight: 600;
          color: ${COLORS.primary_color_shade8 || "#0277BD"};
          text-transform: none;
          letter-spacing: 0;
          padding: 2px 8px;
          border-radius: 999px;
          background: ${COLORS.primary_color_shade0 || "#E1F5FE"};
        }
        .fee-receipt-edit-row {
          display: grid;
          grid-template-columns: minmax(0, 1fr) auto;
          gap: 8px;
          align-items: center;
        }
        .fee-receipt-input {
          width: 100%;
          min-width: 0;
          padding: 8px 12px;
          font-size: 13px;
          font-weight: 600;
          border: 1px solid ${COLORS.grey3 || "#E0E0E0"};
          border-radius: 10px;
          outline: none;
          background: ${COLORS.white};
          box-sizing: border-box;
          transition: border-color 0.15s ease, box-shadow 0.15s ease;
        }
        .fee-receipt-input:focus {
          border-color: ${COLORS.primary_color_shade5 || "#29B6F6"};
          box-shadow: 0 0 0 3px ${COLORS.primary_color_shade1 || "#B3E5FC"}88;
        }
        .fee-receipt-save-btn {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          padding: 8px 16px;
          border-radius: 10px;
          font-weight: 700;
          font-size: 12px;
          background: ${COLORS.primary_color_shade6 || "#039BE5"};
          border: 1px solid ${COLORS.primary_color_shade8 || "#0277BD"};
          color: ${COLORS.white};
          white-space: nowrap;
          cursor: pointer;
          line-height: 1.2;
        }
        .fee-receipt-save-btn:disabled {
          opacity: 0.75;
          cursor: not-allowed;
        }
        .fee-receipt-section {
          border-radius: 16px;
          overflow: hidden;
          border: 1px solid ${COLORS.primary_color_shade2 || "#81D4FA"};
          background: ${COLORS.white};
          box-shadow: 0 4px 16px rgba(2, 136, 209, 0.1);
        }
        .fee-receipt-section-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 12px;
          padding: 12px 16px;
          background: ${HEADER_GRADIENT};
          color: ${COLORS.white};
        }
        .fee-receipt-section-title {
          display: flex;
          align-items: center;
          gap: 10px;
          font-size: 15px;
          font-weight: 800;
          letter-spacing: 0.02em;
        }
        .fee-receipt-section-icon {
          width: 34px;
          height: 34px;
          border-radius: 10px;
          background: rgba(255, 255, 255, 0.2);
          display: inline-flex;
          align-items: center;
          justify-content: center;
          font-size: 15px;
        }
        .fee-receipt-section-badge {
          font-size: 11px;
          font-weight: 600;
          padding: 4px 10px;
          border-radius: 999px;
          background: rgba(255, 255, 255, 0.18);
          border: 1px solid rgba(255, 255, 255, 0.28);
          max-width: 220px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .fee-receipt-loading,
        .fee-receipt-fallback-note {
          display: flex;
          align-items: center;
          gap: 8px;
          margin: 12px 16px 0;
          padding: 10px 12px;
          border-radius: 10px;
          font-size: 12px;
          font-weight: 600;
        }
        .fee-receipt-loading {
          justify-content: center;
          color: ${COLORS.primary_color_shade8 || "#0277BD"};
        }
        .fee-receipt-fallback-note {
          color: ${COLORS.black6 || "#666"};
          background: ${COLORS.grey0 || "#FAFAFA"};
          border: 1px dashed ${COLORS.grey3 || "#E0E0E0"};
        }
        .fee-receipt-templates {
          padding: 12px 16px 0;
        }
        .fee-receipt-templates-label {
          font-size: 11px;
          font-weight: 700;
          color: ${COLORS.black6 || "#64748b"};
          text-transform: uppercase;
          letter-spacing: 0.05em;
          margin: 0 0 10px;
        }
        .fee-receipt-template-grid {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
        }
        .fee-receipt-template-btn {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          min-width: 140px;
          max-width: 220px;
          padding: 10px 12px;
          border-radius: 12px;
          border: 2px solid ${COLORS.grey3 || "#e2e8f0"};
          background: ${COLORS.grey0 || "#f8fafc"};
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
          cursor: pointer;
          transition: all 0.18s ease;
          text-align: left;
        }
        .fee-receipt-template-btn:hover {
          border-color: ${COLORS.primary_color_shade3 || "#4FC3F7"};
          transform: translateY(-1px);
        }
        .fee-receipt-template-btn.is-selected {
          border-color: ${COLORS.primary_color_shade5 || "#29B6F6"};
          background: ${COLORS.primary_color_shade0 || "#E1F5FE"};
          box-shadow: 0 3px 12px ${COLORS.primary_color_shade2 || "#81D4FA"}66;
        }
        .fee-receipt-template-icon {
          width: 28px;
          height: 28px;
          border-radius: 8px;
          background: ${COLORS.white};
          color: ${COLORS.primary_color_shade7 || "#0288D1"};
          display: inline-flex;
          align-items: center;
          justify-content: center;
          font-size: 13px;
          flex-shrink: 0;
        }
        .fee-receipt-template-btn.is-selected .fee-receipt-template-icon {
          background: ${COLORS.primary_color_shade7 || "#0288D1"};
          color: ${COLORS.white};
        }
        .fee-receipt-template-name {
          font-size: 12.5px;
          font-weight: 600;
          color: ${COLORS.black7 || "#475569"};
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .fee-receipt-template-btn.is-selected .fee-receipt-template-name {
          color: ${COLORS.primary_color_shade9 || "#01579B"};
          font-weight: 700;
        }
        .fee-receipt-preview-frame {
          position: relative;
          margin: 12px 16px 16px;
          border-radius: 12px;
          border: 1px solid ${COLORS.primary_color_shade2 || "#81D4FA"};
          background: ${COLORS.grey0 || "#FAFAFA"};
          overflow: hidden;
          min-height: 280px;
        }
        .fee-receipt-preview-overlay {
          position: absolute;
          inset: 0;
          z-index: 2;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 10px;
          background: rgba(255, 255, 255, 0.9);
          color: ${COLORS.primary_color_shade8 || "#0277BD"};
          font-size: 14px;
          font-weight: 600;
        }
        .fee-receipt-preview-overlay .fa-spinner {
          font-size: 28px;
        }
        @media (max-width: 576px) {
          .fee-receipt-edit-row {
            grid-template-columns: 1fr;
          }
          .fee-receipt-section-header {
            flex-direction: column;
            align-items: flex-start;
          }
          .fee-receipt-section-badge {
            max-width: 100%;
          }
          .fee-receipt-template-btn {
            width: 100%;
            max-width: none;
          }
        }
      `}</style>
    </Modal>
  );
};

export default MdlFeePaymentStatus;
